import {RegionalStoreRecord} from 'src/config';
import {IProduct, IProductVariant} from 'src/utils/contentful';

export enum CartTestType {
  SixMonthOffer = 'six_month',
  FreeTrial = 'free_trial',
}

export interface LineItem {
  product: IProduct;
  selectedVariant: IProductVariant;
  quantity: number;
}

export interface Cart {
  lineItems: LineItem[];
  checkoutSessionId: string | null;
  cartTestType: CartTestType | null;
  gift?: boolean;
}

export type RegionalCart = RegionalStoreRecord<Cart>;

export interface StorageLineItem {
  productIds: {
    contentfulProductId: string;
    contentfulVariantId: string;
  };
  quantity: number;
}

export type StorageCart = Omit<Cart, 'lineItems'> & {
  lineItems: StorageLineItem[];
};

export type StorageRegionalCart = RegionalStoreRecord<StorageCart>;

export interface CartActionItem {
  product: IProduct;
  selectedVariant: IProductVariant;
}
